'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var vue_property_decorator_1 = require("vue-property-decorator");
var config_1 = require("../../config");
var vue_1 = tslib_1.__importDefault(require("vue"));
var LinkComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LinkComponent, _super);
    function LinkComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.error = false;
        return _this;
    }
    LinkComponent.prototype.created = function () {
        this.click = this.click.bind(this);
    };
    LinkComponent.prototype.render = function (h) {
        return h(this.tag, {
            attrs: tslib_1.__assign(tslib_1.__assign({}, this.$attrs), { 
                // eslint-disable-next-line quote-props
                'href': this.href, 'is-active': this.isActive }),
            on: {
                click: this.click,
            },
        }, [this.$slots.default]);
    };
    Object.defineProperty(LinkComponent.prototype, "isActive", {
        get: function () {
            // TODO: Accomodate other frameworks rather than just Vue
            // If the isActive handler uses Vue reactivity
            // then vue will accomodate.
            return this.route.isActive ? this.route.isActive() : false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LinkComponent.prototype, "route", {
        get: function () {
            var language = config_1.magicConfig.language;
            if (typeof this.to === 'number' || typeof this.to === 'string') {
                return config_1.magicConfig.getRoute({
                    route: Number(this.to),
                    params: {
                        language: language,
                    },
                });
            }
            return config_1.magicConfig.getRoute(tslib_1.__assign(tslib_1.__assign({}, this.to), { params: tslib_1.__assign(tslib_1.__assign({}, this.to.params), { language: language }) }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LinkComponent.prototype, "href", {
        get: function () {
            if (this.route.hasOwnProperty('href')) {
                return this.route.href;
            }
            else {
                return 'javascript:void(0)';
            }
        },
        enumerable: false,
        configurable: true
    });
    LinkComponent.prototype.click = function (e) {
        if (!this.route.href) {
            e.preventDefault();
            this.route.go();
        }
    };
    tslib_1.__decorate([
        vue_property_decorator_1.Prop({
            validator: function (value) {
                return (typeof value === 'number' ||
                    typeof value === 'string' ||
                    typeof value === 'object');
            },
        })
    ], LinkComponent.prototype, "to", void 0);
    tslib_1.__decorate([
        vue_property_decorator_1.Prop({
            type: String,
            default: 'a',
        })
    ], LinkComponent.prototype, "tag", void 0);
    tslib_1.__decorate([
        vue_property_decorator_1.Emit('click')
    ], LinkComponent.prototype, "click", null);
    LinkComponent = tslib_1.__decorate([
        vue_property_decorator_1.Component
    ], LinkComponent);
    return LinkComponent;
}(vue_1.default));
exports.default = LinkComponent;
